export default "__VITE_ASSET__E7oljf8x__"